<div class="jumbotron transition">
  <div
    class="background__container container mx-auto flex sm:flex-row flex-col"
  >
    <div class="landing__header flex flex-col gap-4 flex-1">
      <h1 [innerHTML]="safeHtmlTitle()"></h1>
      <p class="text-clip" translate="homeDes_1"></p>
      <p class="text-clip" translate="homeDes_2"></p>

      <div class="download__methods flex gap-4 mt-4">
        <a
          href="https://chromewebstore.google.com/search/posty5?hl={{
            i18nService.language
          }}&authuser=0"
          class="primary__btn text-center inline-flex items-center me-2 mb-2"
        >
          <div inlineSVG="footer/chrome-extensions.svg" class="mr-2 ml-2"></div>
          {{ "Chrome Extensions" | translate | async }}
        </a>
      </div>
    </div>

    <app-statistics-section-2 class="flex-1"></app-statistics-section-2>
  </div>
</div>
